import request from '@/utils/httpRequest'

export default {
  save: function (inputForm) {
    return request({
      url: '/cecunmsetmeal/cecUnmSetMeal/save',
      method: 'post',
      data: inputForm
    })
  },
  batchOperation: function (inputForm) {
    return request({
      url: '/cecunmsetmeal/cecUnmSetMeal/batchOperation',
      method: 'post',
      data: inputForm
    })
  },

  delete: function (ids) {
    return request({
      url: '/cecunmsetmeal/cecUnmSetMeal/delete',
      method: 'delete',
      params: {ids: ids}
    })
  },

  queryById: function (id) {
    return request({
      url: '/cecunmsetmeal/cecUnmSetMeal/queryById',
      method: 'get',
      params: {id: id}
    })
  },

  list: function (params) {
    return request({
      url: '/cecunmsetmeal/cecUnmSetMeal/list',
      method: 'get',
      params: params
    })
  },

  exportTemplate: function () {
    return request({
      url: '/cecunmsetmeal/cecUnmSetMeal/import/template',
      method: 'get',
      responseType: 'blob'
    })
  },

  exportExcel: function (params) {
    return request({
      url: '/cecunmsetmeal/cecUnmSetMeal/export',
      method: 'get',
      params: params,
      responseType: 'blob'
    })
  },

  importExcel: function (data) {
    return request({
      url: '/cecunmsetmeal/cecUnmSetMeal/import',
      method: 'post',
      data: data
    })
  }
}
